import { CountBadge } from '@vrplatform/components';
import { useAccountsAssignmentsMissingQuery } from '@vrplatform/data';
import { Icon } from '@vrplatform/icons';
import { Stack, Title, Tooltip } from '@mantine/core';
import { useNavbarExpanded } from '../hooks';
import { NavbarRoute } from '../layout/navbar';
import { PartnerRegionSwitch } from './PartnerRegionSwitch';
import { platformDefaultsSubRoutes } from './platformDefaultsNavigation.routes';

const iconSize = 18;

export function VrpNavigation() {
  const { isDesktopExpanded } = useNavbarExpanded();

  return (
    <>
      <PartnerRegionSwitch />

      <Stack gap="xs" mb="md">
        {isDesktopExpanded && (
          <Title order={5} c="white" fw={400} ml={8}>
            VRPlatform Data
          </Title>
        )}

        <NavbarRoute
          title="Statements"
          link={'/statements'}
          icon={<Icon icon="ClipboardTextIcon" size={iconSize} />}
        />

        <NavbarRoute
          title="Connections"
          link={'/team-connections?status=active'}
          icon={<Icon icon="ShareIcon" size={iconSize} />}
        />
      </Stack>

      <Stack gap="xs" mb="md">
        {isDesktopExpanded && (
          <Title order={5} c="white" fw={400} ml={8}>
            VRPlatform Teams
          </Title>
        )}
        <NavbarRoute
          title="Partners"
          link={'/partner'}
          icon={<Icon icon="OfficeIcon" size={iconSize} />}
        />
        <NavbarRoute
          title="Property Managers"
          link={'/property-manager'}
          icon={<Icon icon="HomeIcon" size={iconSize - 1} />}
        />
        <NavbarRoute
          title="Users"
          link={'/users'}
          icon={<Icon icon="UsersIcon" size={iconSize - 1} />}
        />
      </Stack>

      <Stack gap="xs" mb="md">
        {isDesktopExpanded && (
          <Title order={5} c="white" fw={400} ml={8}>
            VRPlatform Admin
          </Title>
        )}

        <NavbarRoute
          title="Billing"
          link={'/billing'}
          icon={<Icon icon="CircleDollarIcon" size={iconSize} />}
        />
        <NavbarRoute
          title="Feature Testing"
          link="/features"
          icon={<Icon icon="RocketIcon" size={iconSize} />}
        />

        <NavbarRoute
          title="VRP Admins"
          link={'/members'}
          icon={<Icon icon="UsersIcon" size={iconSize} />}
        />
      </Stack>

      <Stack gap="xs">
        {isDesktopExpanded && (
          <Title order={5} c="white" fw={400} ml={8}>
            VRPlatform Defaults
          </Title>
        )}

        <NavbarRoute
          title="Booking Channels"
          link={'/booking-channels'}
          icon={<Icon icon="BookingComIcon" size={iconSize} />}
        />

        <NavbarRoute
          title="Message Overwrites"
          link="/message-overwrites"
          icon={<Icon icon="NoteTextIcon" size={iconSize} />}
        />
        <NavbarRoute
          title="Transaction Line Mappings"
          link={'/line-mappings'}
          icon={<Icon icon="BookOpenIcon" size={iconSize} />}
        />
        <NavbarRoute
          title="General Ledger Defaults"
          link="/platform-defaults/general-ledger"
          icon={<Icon icon="GearIcon" size={iconSize} />}
          notification={<ChartOfAccountIssueBadge />}
          subRoutes={platformDefaultsSubRoutes}
        />
      </Stack>
    </>
  );
}

const ChartOfAccountIssueBadge = () => {
  const { data, isLoading } = useAccountsAssignmentsMissingQuery();
  const count = data.length;

  if (isLoading) return <CountBadge count={0} loading loadingColor="white" />;

  if (!count) return null;

  return (
    <Tooltip
      label={`${count} missing account assignments`}
      withArrow
      disabled={!count}
    >
      <CountBadge count={count} loading={isLoading} loadingColor="white" />
    </Tooltip>
  );
};
